/*
  Perro Loco — Agregar al carro desde la tarjeta de producto
  Épica 2, historias 2.1, 2.5 y 2.6.

  Uso:
    <pl-agregar>
      <form action="/cart/add" method="post">...<button type="submit">...</button></form>
      <div class="pl-card__error" role="alert" hidden><span></span></div>
    </pl-agregar>

  Por qué no se usa <product-form> del tema:
  - Su .catch() solo escribe en la consola: si se cae la red, el cliente no ve nada.
  - Depende de un <span> interno del botón y de una estructura de error que la
    tarjeta no tiene.
  Lo que sí se reutiliza es cart-drawer.renderContents(), que ya resuelve el
  foco atrapado, el cierre con Esc y la devolución del foco.
*/

if (!customElements.get('pl-agregar')) {
  customElements.define(
    'pl-agregar',
    class PlAgregar extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.boton = this.querySelector('[type="submit"]');
        this.errorCaja = this.querySelector('.pl-card__error');
        this.errorTexto = this.errorCaja && this.errorCaja.querySelector('span');
        if (!this.form || !this.boton) return;

        this.form.addEventListener('submit', this.alEnviar.bind(this));
      }

      get carro() {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      }

      alEnviar(evento) {
        evento.preventDefault();
        // Apretar dos veces agregaría dos unidades (historia 2.6).
        if (this.boton.getAttribute('aria-busy') === 'true') return;

        this.mostrarError(false);
        this.trabajando(true);

        const carro = this.carro;
        const datos = new FormData(this.form);

        if (carro) {
          datos.append('sections', carro.getSectionsToRender().map((s) => s.id));
          datos.append('sections_url', window.location.pathname);
          carro.setActiveElement(this.boton);
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: datos,
        })
          .then((r) => r.json())
          .then(async (respuesta) => {
            // Shopify devuelve `status` solo cuando algo salió mal.
            if (respuesta.status) {
              const mensaje = respuesta.description || respuesta.message;
              // …pero "salió mal" incluye el agregado parcial: si se pidieron 5
              // y quedaban 2, los 2 entraron igual. Mostrar solo el error deja
              // al cliente creyendo que no compró nada. Ver pl-carro-lateral.js.
              const entroAlgo = await window.plCarro?.rescatarAgregadoParcial(mensaje);
              if (!entroAlgo) this.mostrarError(mensaje);
              return;
            }
            if (!carro) {
              window.location = window.routes.cart_url;
              return;
            }
            carro.classList.remove('is-empty');
            carro.renderContents(respuesta);
            window.plCarro?.recordarConteo();
          })
          .catch(() => {
            this.mostrarError('No pudimos agregarlo. Revisa tu conexión y vuelve a intentarlo.');
          })
          .finally(() => this.trabajando(false));
      }

      trabajando(activo) {
        this.boton.setAttribute('aria-busy', activo ? 'true' : 'false');
        const spinner = this.boton.querySelector('.pl-card__spinner');
        if (spinner) spinner.toggleAttribute('hidden', !activo);
      }

      mostrarError(mensaje) {
        if (!this.errorCaja || !this.errorTexto) return;
        this.errorCaja.toggleAttribute('hidden', !mensaje);
        this.errorTexto.textContent = mensaje || '';
      }
    }
  );
}
